<template>
	<Card :title="$t('loginPage.title')">
		<Form
			:model="formState"
			:label-col="{ span: 12 }"
			:wrapper-col="{ span: 12 }"
			:colon="false"
			autocomplete="off"
		>
			<FormItem
				:label="$t('common.login')"
				name="username"
				v-bind="validateInfos.username"
			>
				<Input
					ref="usernameField"
					aria-label="Login"
					v-model:value="formState.username"
					@keyup.enter="onSubmit"
				/>
			</FormItem>

			<FormItem
				:label="$t('common.password')"
				name="password"
				v-bind="validateInfos.password"
			>
				<InputPassword
					aria-label="Password"
					v-model:value="formState.password"
					@keyup.enter="onSubmit"
				/>
			</FormItem>
		</Form>
		<template #actions>
			<Button type="primary" @click.prevent="onSubmit" :loading="isLoading">{{ $t('loginPage.buttonLabel') }}</Button>
		</template>
	</Card>
</template>

<script>
import { reactive, ref, onMounted, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

import { Form, FormItem, Input, InputPassword, Button, Card, message } from 'ant-design-vue'

import ApiOps from '@/api/ApiOps'

import { useBaseStationsStore } from '@/stores/baseStations'

const useForm = Form.useForm;

export default {
	components: {
		Form, FormItem, Input, InputPassword, Button, Card,
	},
	setup() {
		const router = useRouter();
		const { t } = useI18n();
		const baseStationsStore = useBaseStationsStore();

		const formState = reactive({
			username: '',
			password: '',
		});

		const rulesRef = reactive({
			username: [{ required: true, message: t('validators.usernameRequiredMessage') }],
			password: [{ required: true, message: t('validators.passwordRequiredMessage') }],
		});

		const { validate, validateInfos } = useForm(formState, rulesRef);
		const isLoading = ref(false);
		const usernameField = ref(null);

		const onSubmit = () => validate().then(() => {
			isLoading.value = true;
			ApiOps.getToken(
				formState.username,
				formState.password,
				(redirectName) => {
					isLoading.value = false;
					baseStationsStore.setAutoUpdates(true);
					router.push({ name: redirectName });
				},
				(error) => {
					isLoading.value = false;
					if (error.response?.status === 429) {
						message.error(t('common.tooManyRequests'));
						return;
					}
					const errors = error.response.data.non_field_errors;
					if (errors) {
						message.error(errors[0]);
					}
				},
			)
		}).catch(() => {
			isLoading.value = false
		});

		onMounted(() => {
			nextTick(() => {
				if (usernameField.value?.focus) {
					usernameField.value.focus()
				}
			})
		});

		return {
			formState,
			validateInfos,
			isLoading,
			onSubmit,
			usernameField,
		}
	},
}
</script>
